import styled from "styled-components";
import { Icon, ModalContainer, ModalRoot } from "components/atoms";
import { IconName } from "interfaces/icons";
import { BaseModalProps } from "interfaces/modals";
import { FONT_FAMILY_BOLD, FONT_FAMILY_REGULAR } from "styles/typography";
import { MAIN_THEME } from "styles/colors";
import { ColumnDefinition } from "hooks/useColumnPreferences";

const CloseButton = styled.button`
    border: 1px solid #ffffff;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 30px;
    top: 30px;
    cursor: pointer;
    outline: none;
    background: transparent;
`;

const Content = styled.div`
    width: 400px;
    padding: 10px;
`;

const Title = styled.p`
    font-family: ${FONT_FAMILY_BOLD};
    font-weight: bold;
    font-size: 24px;
    color: #ffffff;
    margin-bottom: 30px;
    text-align: center;
`;

const ColumnList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    max-height: 400px;
    overflow-y: auto;
`;

const ColumnItem = styled.label`
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 10px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.05);
    transition: background 0.2s;

    &:hover {
        background: rgba(255, 255, 255, 0.1);
    }
`;

const Checkbox = styled.input`
    margin-right: 15px;
    width: 18px;
    height: 18px;
    cursor: pointer;
    accent-color: ${MAIN_THEME.SECONDARY};
`;

const Label = styled.span`
    color: #ffffff;
    font-family: ${FONT_FAMILY_REGULAR};
    font-size: 16px;
`;

interface Props extends BaseModalProps {
    columns: ColumnDefinition[];
    onToggle: (id: string) => void;
}

const ColumnSettingsModal = (props: Props): JSX.Element => {
    const { isVisible, close, columns, onToggle } = props;

    return isVisible ? (
        <ModalRoot onClick={close}>
            <ModalContainer>
                <CloseButton onClick={close}>
                    <Icon name={IconName.CLOSE} color="#ffffff" />
                </CloseButton>
                <Content>
                    <Title>Table Columns</Title>
                    <ColumnList>
                        {columns.map(col => (
                            <ColumnItem key={col.id}>
                                <Checkbox
                                    type="checkbox"
                                    checked={col.isVisible}
                                    onChange={() => onToggle(col.id)}
                                />
                                <Label>{col.label}</Label>
                            </ColumnItem>
                        ))}
                    </ColumnList>
                </Content>
            </ModalContainer>
        </ModalRoot>
    ) : (
        <></>
    );
};

export default ColumnSettingsModal;
